import QrGenerationView from './QrGenerationView';
import './QrGenerationView.scss';

export default QrGenerationView;
